import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-276249cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-test"]
const _hoisted_2 = ["id", "tabindex", "data-index", "aria-label"]

import { reactive, ref, onMounted, nextTick, computed, watch } from 'vue'
import useRemedyCategoryBackgroundColor from '@/composables/useRemedyCategoryBackgroundColor'
import CollectStormwaterIcon from '@/assets/svg/CollectStormwaterIcon.vue'
import ImprovePublicSpaceIcon from '@/assets/svg/ImprovePublicSpaceIcon.vue'
import ImproveTransitIcon from '@/assets/svg/ImproveTransitIcon.vue'
import PlantVegetationIcon from '@/assets/svg/PlantVegetationIcon.vue'
import RestoreWaterBodyIcon from '@/assets/svg/RestoreWaterBodyIcon.vue'
import AudioIcon from '@/assets/svg/AudioIcon.vue'
import VideoIcon from '@/assets/svg/VideoIcon.vue'
import InfoIcon from '@/assets/svg/InfoIcon.vue'
import { HotSpotData, ImageBackgroundState } from './types'
import { useEventBus } from '@vueuse/core'
import { useSettingsStore } from '@/store/settings'
import useTabIndex from '@/composables/mjp/useTabIndex'
import HotspotContainer from './HotspotContainer.vue'
import HotSpotVue from '@/components/general/HotSpot.vue'

interface Props {
  backgroundState: ImageBackgroundState
  hotspotData: HotSpotData
  dir: string
  visible: boolean
  hoveredHotspotId: string
  index: number
  sectionText: object
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HotSpot',
  props: {
    backgroundState: null,
    hotspotData: null,
    dir: null,
    visible: { type: Boolean },
    hoveredHotspotId: null,
    index: null,
    sectionText: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  backgroundState: ImageBackgroundState
  hotspotData: HotSpotData
  dir: string
  visible: boolean
  hoveredHotspotId: string
  index: number
  sectionText: object
}


const element = ref(null)
const popoverClosedBus = useEventBus('popover-closed')
const hotspotHoveredBus = useEventBus('hotspot-hovered')
const hotspotNotHoveredBus = useEventBus('hotspot-not-hovered')
const hotspotClickedBus = useEventBus('hotspot-clicked')
const settingsStore = useSettingsStore()
const windowSize = {
  x: window.innerWidth,
  y: window.innerHeight,
}
const state = reactive({
  isVisible: false,
  element: null,
  isPopoverOpen: false,
  isAnimationPlaying: false,
  delay: Math.random() * -3, // randomize animation start time
  isDisplayed: false,
})

expose({ state })

const handleResize = () => {
  updateWindowSize()
  if (element.value) {
    state.isVisible = isInViewport(element.value)
    state.element = element.value
  }
}

const updateWindowSize = () => {
  windowSize.x = window.innerWidth
  windowSize.y = window.innerHeight
}

const isInViewport = (element) => {
  if (windowSize.x < 768) {
    return false
  } else {
    const rect = element.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (windowSize.y || document.documentElement.clientHeight) &&
      rect.right <= (windowSize.x || document.documentElement.clientWidth)
    )
  }
}

// TODO: this is duplicative of the remedy badge
const remedyCategoryIcons = {
  collectStormwater: CollectStormwaterIcon,
  plantVegetation: PlantVegetationIcon,
  improveTransit: ImproveTransitIcon,
  improvePublicSpace: ImprovePublicSpaceIcon,
  restoreWaterBody: RestoreWaterBodyIcon,
  audio: AudioIcon,
  video: VideoIcon,
  info: InfoIcon,
}

popoverClosedBus.on(() => {
  state.isAnimationPlaying = false
  state.isPopoverOpen = false
})

const handleMouseOver = (evt) => {
  state.isAnimationPlaying = true
  const hotSpotIndex = getHotspotIndexFromElement(
    evt.currentTarget.parentElement
  )
  hotspotHoveredBus.emit(hotSpotIndex)
}

const handleMouseOut = (evt) => {
  state.isAnimationPlaying = state.isPopoverOpen
  hotspotNotHoveredBus.emit(-1)
}

const getHotspotIndexFromElement = (element) => {
  const hotSpotIndex = parseInt(element.getAttribute('data-test').split('-')[1])
  return hotSpotIndex
}

const handleClick = (evt) => {
  state.isPopoverOpen = true
  const hotSpotIndex = getHotspotIndexFromElement(
    evt.currentTarget.parentElement
  )
  hotspotClickedBus.emit(hotSpotIndex)
  evt.stopPropagation()
}

hotspotHoveredBus.on(() => {
  nextTick(() => {
    if (
      props.hoveredHotspotId != props.hotspotData.id &&
      props.hoveredHotspotId != ''
    ) {
      state.isAnimationPlaying = false
    }
  })
})

const borderClasses = computed(() => {
  if (settingsStore.highContrast) {
    return 'border-[3px] border-stone border-solid'
  } else {
    return ''
  }
})

const pointerEventsClasses = computed(() => {
  let classes = ''
  if (!state.isDisplayed) {
    classes = 'invisible '
  }
  if (props.visible) {
    classes += 'cursor-pointer pointer-events-auto'
  } else {
    classes += 'pointer-events-none'
  }
  return classes
})

onMounted(() => {
  state.isDisplayed = props.visible
  nextTick(() => {
    handleResize()
  })
})

watch(
  () => props.visible,
  (currentValue, previousValue) => {
    if (currentValue) {
      state.isDisplayed = true
    } else {
      setTimeout(() => {
        state.isDisplayed = false
      }, 1000)
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _directive_resize = _resolveDirective("resize")!

  return (_openBlock(), _createElementBlock("div", {
    "data-test": 'hotspot-' + props.index
  }, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      id: `hotspot-${props.hotspotData.id}`,
      ref_key: "element",
      ref: element,
      onMouseover: handleMouseOver,
      onMouseout: handleMouseOut,
      onClick: handleClick,
      tabindex: _unref(useTabIndex)(HotspotContainer, props.index, HotSpotVue, -1),
      class: _normalizeClass(["hotspot absolute focus:outline-none focus-visible:ring rounded-full drop-shadow items-center justify-center hidden sm:flex", 
        _unref(useRemedyCategoryBackgroundColor)(
          props.hotspotData.popover.remedyCategory
        ) +
        ' ' +
        _unref(pointerEventsClasses) +
        ' ' +
        _unref(borderClasses)
      ]),
      style: _normalizeStyle({
        left:
          (props.hotspotData.left / props.backgroundState.naturalWidth) * 100 +
          '%',
        top:
          (props.hotspotData.top / props.backgroundState.naturalHeight) * 100 +
          '%',
        width: props.backgroundState.hotspotSize + 'px',
        height: props.backgroundState.hotspotSize + 'px',
        marginLeft: -(props.backgroundState.hotspotSize * 0.5) + 'px',
        marginTop: -(props.backgroundState.hotspotSize * 0.5) + 'px',
        paddingLeft: props.backgroundState.hotspotSize * 0.21 + 'px',
        paddingRight: props.backgroundState.hotspotSize * 0.21 + 'px',
        animationDelay: state.delay + 's',
        opacity: props.visible ? 1 : 0,
      }),
      "data-index": props.index,
      "aria-label": props.sectionText[props.hotspotData.preview.text]
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(remedyCategoryIcons[props.hotspotData.popover.remedyCategory]), { class: "w-5/6 h-5/6" }))
    ], 46, _hoisted_2)), [
      [_directive_resize, handleResize]
    ])
  ], 8, _hoisted_1))
}
}

})